import type { PropsWithChildren } from 'react';
import { ReactFlowProvider } from '@xyflow/react';
import DragAndDropProvider from '../contexts/DragAndDropProvider';
import SelectedNodeIdProvider from '../contexts/SelectedNodeIdProvider';

const FlowWrapper = ({ children }: PropsWithChildren) => {
    return (
        <ReactFlowProvider>
            <DragAndDropProvider>
                <SelectedNodeIdProvider>{children}</SelectedNodeIdProvider>
            </DragAndDropProvider>
        </ReactFlowProvider>
    );
};

export default FlowWrapper;
